import { useSelector } from 'react-redux';
import useLaunchCurrencyPayWindow from './launchCurrencyPayWindow';
import { iRootState } from './redux/store';

const useOpenCurrencyPayWindowToPayTotal = function useOpenCurrencyPayWindowToPayTotal(): {
  openCurrencyPayWindow: () => void;
} {
  const { launchCurrencyPayWindow } = useLaunchCurrencyPayWindow();
  const total = useSelector((state: iRootState) => state.quote.total);
  const items = useSelector((state: iRootState) => state.quote.items);
  const orderId = useSelector((state: iRootState) => state.quote.id);
  const orderDesc = useSelector((state: iRootState) => state.quote.projectName);
  const tax = useSelector((state: iRootState) => state.quote.tax);
  const shipping = useSelector((state: iRootState) => state.quote.freightTotal);
  const useFortis = useSelector(
    (state: iRootState) => state.quote.useFortisPayment
  );
  const dealerId = useSelector((state: iRootState) => state.quote.dealerId);

  const paymentMethods = useSelector(
    (state: iRootState) => state.currencyPay.config.paymentMethods
  );
  const hasACH = paymentMethods.BankWire;
  const hasСС = paymentMethods.CreditCard;
  const currencyItems = items
    .filter(item => item.price > 0)
    .map(item => ({
      itemId: item.itemId,
      itemDescription: item.description,
      itemPrice: item.price,
      itemQty: item.quantity,
      um: item.um === 'ea' ? 'each' : item.um,
      productCode: item.productCode
    }));
  const openCurrencyPayWindow = () =>
    launchCurrencyPayWindow(
      total,
      currencyItems,
      orderId,
      orderDesc,
      tax,
      shipping,
      useFortis,
      hasACH,
      hasСС,
      dealerId
    );
  return { openCurrencyPayWindow };
};

export default useOpenCurrencyPayWindowToPayTotal;
